module.exports = __webpack_public_path__ + "static/media/TerryPorterPic.1d769932.jpg";